const pixelHeadScript = `<script src="https://pixel.scoring.ru/pixel.js" async></script>`;
const pixelBodyScript = `<div id="pixel2" data-pid="81" data-uid="c2cc7947-8e04-4f8b-b3ba-4321d9a713af"></div>`;

module.exports = {
    pixelHeadScript,
    pixelBodyScript
};
